import { createContext, use, useMemo, type ReactNode } from "react";
import type { FeedbackContext } from "@/lib/support/support-client";

const ScopeContext = createContext<FeedbackContext>({});

/**
 * The ids a part of the app is about, for every error drawn inside it to carry in its report:
 * a draft's layout gives its draft id, a run's page adds the run's. A scope inside another adds
 * to it. Pass `ids` held steady (memoised), or every reader below re-renders with the scope.
 */
export function ProblemScope({
  ids,
  children,
}: {
  ids: FeedbackContext;
  children: ReactNode;
}) {
  const outer = use(ScopeContext);
  const merged = useMemo(() => ({ ...outer, ...ids }), [outer, ids]);
  return <ScopeContext value={merged}>{children}</ScopeContext>;
}

/** The ids of the scopes around this component. */
export function useProblemScope(): FeedbackContext {
  return use(ScopeContext);
}
